import api from '../lib/api';
import { toArray } from '../lib/utils';
import type {
  FallbackRequest,
  FallbackRequestFilters,
  FallbackRequestResponse,
} from '../types/fallback';

class FallbackService {
  async getRequests(filters: FallbackRequestFilters = {}): Promise<FallbackRequestResponse> {
    const response = await api.get('/fallback/requests', { params: filters });
    return response.data;
  }

  async getRequest(id: number): Promise<FallbackRequest> {
    const response = await api.get(`/fallback/requests/${id}`);
    return response.data;
  }

  async createRequest(data: Partial<FallbackRequest>): Promise<FallbackRequest> {
    const response = await api.post('/fallback/requests', data);
    return response.data;
  }

  async updateRequest(id: number, data: Partial<FallbackRequest>): Promise<FallbackRequest> {
    const response = await api.put(`/fallback/requests/${id}`, data);
    return response.data;
  }

  async deleteRequest(id: number): Promise<void> {
    await api.delete(`/fallback/requests/${id}`);
  }

  async getAssistants(): Promise<any[]> {
    const response = await api.get('/assistants');
    return toArray(response.data);
  }

  async getWhatsappSessions(): Promise<any[]> {
    const response = await api.get('/whatsapp/sessions');
    return toArray(response.data);
  }
}

export default new FallbackService();
